<template>
    <div class="page">
        <div class="header">
            <div class="back" @click="$emit('close')">  
                <img src="../assets/icon-prev.svg" alt="">
                <span>返回</span>    
            </div>
            <div class="title">思维导图</div>
        </div>
        <iframe :src="url" frameborder="0" style="height:100%;width:100%"></iframe>
    </div>
</template>

<script>
import { mapState } from 'vuex'
    export default {
        data(){
            const state = this.$store.getters.info
            let url = `https://s10.mamale.vip/mind/${state.role ==2?'index':'show'}.html?booksubid=${state.bookSubId}`
            return {
                url
            }
        }
    }
</script>

<style  scoped>
    .page{
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 9999999;
        height: 100%;
        background: white;
    }
    .header{
        width: 100%;
        height: 48px;
        line-height: 48px;
        background-color: #4D97FE;
    }
    .title{
        text-align: center;
        color: white;
    }
    .back{
        float: left;
        color: white;
        vertical-align: middle;
        margin-left: 15px;
        cursor: pointer;
    }
    img{
        vertical-align: middle;
    }
</style>


// WEBPACK FOOTER //
// src/pages/Mind.vue